import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { takeUntil, Subject } from 'rxjs';

import { filterBoolean } from '@recruitee/common';
import { RequisitionsSelectors, RequisitionsActions } from '@recruitee/requisitions-data';
import type { RequisitionOpening } from '@recruitee/requisitions-types';
import { RequisitionOpeningStatus } from '@recruitee/requisitions-types';

import { RequisitionsHiresContainerComponent } from '../../../containers/single-requisition/requisitions-hires-container/requisitions-hires-container.component';
import { HiresFacade } from '../../../facades/single-requisition/hires.facade';
import { placementChanges$ } from '../../../helpers/placement-changes';

@Component({
  selector: 'rt-requisitions-hires-page',
  templateUrl: './hires-page.component.html',
  styleUrls: ['./hires-page.component.less'],
  imports: [RequisitionsHiresContainerComponent],
  providers: [HiresFacade],
})
export class HiresPageComponent {
  public filledOpenings: RequisitionOpening[];
  public requisitionId: number;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private actions$: Actions,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    const id = Number(this.route.parent?.snapshot.params.id);

    this.store
      .select(RequisitionsSelectors.byId(id))
      .pipe(filterBoolean, takeUntil(this.ngOnDestroy$))
      .subscribe(data => {
        this.requisitionId = data.id;
        this.filledOpenings = data.openings.filter(
          opening => opening.status === RequisitionOpeningStatus.Filled,
        );
        this.cdRef.detectChanges();
      });

    this.subscribeToPlacementChanges();
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  private subscribeToPlacementChanges(): void {
    placementChanges$(this.actions$)
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(() => {
        this.store.dispatch(RequisitionsActions.fetchOne({ payload: { id: this.requisitionId } }));
      });
  }
}
